import type { ICancellation } from "@/data/model/Cancellation";
import type { ICreditCard } from "@/data/model/CreditCard";
import type { IOrderPaymentConfirmation } from "@/data/model/Customer";
import { DeallocationReason } from "@/data/model/Enums";
import type { BillItemSelectionChangedEvent, IAllocationuseCaseChangedEvent, IBillChangedEvent, IBillChangedSharedEvent, IBillClosedEvent, IBillDiscountChangedEvent, IBillDiscountChangedSharedEvent, IBillEvent, IBillManualEndUsersCountChangedEvent, IBillNameChangedEvent, IBillOpenedEvent, ICartChangedEvent, ICartDiscountChangedEvent, ICertificateEncodingProgressEvent, ICustomerFulfillmentChangedEvent, ICustomerLinkedFulfillmentsChangedEvent, ICustomerOfferNeedsRefreshEvent, IEmailConfirmedEvent, IFulfillmentPositionsChangedEvent, IIdentityDiscoveredEvent, IIdentityEmailChangedEvent, ILinkedFulfillmentPositionsChangedEvent, IOrderCancelledEvent, IOrderOutstandingChangedEvent, IPayLaterOrderConfirmedEvent, IProfileChangedEvent, IReservationTableAssignmentChangedEvent, IRoomOfferActivationChangedEvent, IRoomPlanChangedEvent, ITableCovidUserCountChangedEvent, UserAllocatedEvent, UserDeallocatedEvent } from "@/data/model/Events";
import { Signal, TypedSignal } from "@/data/util/Signal";


export const dataEvents = {
    // app socket events
    appSocket: {
        ItemSelectionChanged: new TypedSignal<BillItemSelectionChangedEvent>(),
        AllocationChange: new TypedSignal<DeallocationReason | undefined>(),
        UserAllocated: new TypedSignal<UserAllocatedEvent>(),
        UserDeallocated: new TypedSignal<UserDeallocatedEvent>(),
        AllocationUseCaseChange: new TypedSignal<IAllocationuseCaseChangedEvent>(),
        TableCovidUserCountChanged: new TypedSignal<ITableCovidUserCountChangedEvent>(),
        EmailConfirmed: new TypedSignal<IEmailConfirmedEvent>(),
        CartChanged: new TypedSignal<ICartChangedEvent>(),
        CartDiscountChanged: new TypedSignal<ICartDiscountChangedEvent>(),
        OfferChanged: new TypedSignal<ICustomerOfferNeedsRefreshEvent>(),
        PaymentConfirmed: new TypedSignal<IOrderPaymentConfirmation>(),
        FulfillmentChanged: new TypedSignal<ICustomerFulfillmentChangedEvent>(),
        LinkedFulfillmentsChanged: new TypedSignal<ICustomerLinkedFulfillmentsChangedEvent>(),
        FulfillmentPositionsChanged: new TypedSignal<IFulfillmentPositionsChangedEvent>(),
        LinkedFulfillmentsPositionsChanged: new TypedSignal<ILinkedFulfillmentPositionsChangedEvent>(),
        IdentityDiscovered: new TypedSignal<IIdentityDiscoveredEvent>(),
        IdentityEmailChanged: new TypedSignal<IIdentityEmailChangedEvent>(),
        ProfileChanged: new TypedSignal<IProfileChangedEvent>(),
        CreditCardAttached: new TypedSignal<ICreditCard>(),
        CreditCardDetached: new TypedSignal<string>(),
        CertificateEncodingProgress: new TypedSignal<ICertificateEncodingProgressEvent>(),
        RoomOfferActivationChanged: new TypedSignal<IRoomOfferActivationChangedEvent>(),
        BillOpened: new TypedSignal<IBillOpenedEvent>(),
        BillChanged: new TypedSignal<IBillChangedEvent>(),
        BillChangedShared: new TypedSignal<IBillChangedSharedEvent>(),
        BillDiscountChanged: new TypedSignal<IBillDiscountChangedEvent>(),
        BillDiscountChangedShared: new TypedSignal<IBillDiscountChangedSharedEvent>(),
        BillNameChanged: new TypedSignal<IBillNameChangedEvent>(),
        BillManualEndUsersCountChanged: new TypedSignal<IBillManualEndUsersCountChangedEvent>(),
        BillClosed: new TypedSignal<IBillClosedEvent>(),
        UserSignedOut: new Signal(),
        UserSessionExpired: new Signal(),
        RoomPlanChanged: new TypedSignal<IRoomPlanChangedEvent>(),
        TransferBillItemsDisabled: new TypedSignal<IBillEvent>(),
    },
    // operator socket events
    operatorSocket: {
        TableCovidUserCountChanged: new TypedSignal<ITableCovidUserCountChangedEvent>(),
        RoomPlanChanged: new TypedSignal<IRoomPlanChangedEvent>(),
        OperatorUserSignedOut: new Signal(),
        OrderOutstandingChanged: new TypedSignal<IOrderOutstandingChangedEvent>(),
        PayLaterOrderConfirmed: new TypedSignal<IPayLaterOrderConfirmedEvent>(),
        FulfillmentChanged: new Signal(),
        LinkedFulfillmentsChanged: new Signal(),
        FulfillmentPositionsChanged: new TypedSignal<IFulfillmentPositionsChangedEvent>(),
        LinkedFulfillmentsPositionsChanged: new TypedSignal<ILinkedFulfillmentPositionsChangedEvent>(),
        OrderCancelled: new TypedSignal<IOrderCancelledEvent>(),
        BillOpened: new TypedSignal<IBillOpenedEvent>(),
        BillChanged: new TypedSignal<IBillChangedEvent>(),
        BillNameChanged: new TypedSignal<IBillNameChangedEvent>(),
        BillManualEndUsersCountChanged: new TypedSignal<IBillManualEndUsersCountChangedEvent>(),
        BillClosed: new TypedSignal<IBillClosedEvent>(),
        TransferBillItemsDisabled: new TypedSignal<IBillEvent>(),
        UserSessionExpired: new Signal(),
        BillDiscountChanged: new TypedSignal<IBillDiscountChangedEvent>(),
        ReservationTableAssignmentChanged: new TypedSignal<IReservationTableAssignmentChangedEvent>(),
    },
};
